








































































































import { Component, Vue, Watch } from "vue-property-decorator";
import productoModule from "@/store/modules/producto-module";
import pedidoModule from "@/store/modules/pedido-module";
import { producto } from "@/shared/dtos/producto";
import { RouterNames } from "@/router/routernames";
import { API } from "@/shared/api";

@Component
export default class AnalisisStockLote extends Vue {
  cargando = false;
  estadoFiltro = "todos";
  search = "";
  productos: producto[] = [];
  pedidoIds: number[] = [];

  async created() {
    await this.cargarDatos();
  }

  @Watch("pedidoIds")
  onPedidoIdsChange(newVal: number[], oldVal: number[]) {
    // Si cambian desde el select, actualizamos la url silenciosamente
    if (newVal.join(",") !== oldVal.join(",")) {
      this.$router.replace({ query: { ...this.$route.query, pedidos: newVal.join(",") } }).catch(()=>{});
    }
  }

  async cargarDatos() {
    this.cargando = true;
    const queryIds = this.$route.query.pedidos;
    if (queryIds && typeof queryIds === "string") {
      this.pedidoIds = queryIds.split(",").filter(x => x).map(x => Number(x));
    } else {
      this.pedidoIds = [];
    }
    
    // Si no están cargados, los cargamos
    if (productoModule.productos.length === 0) {
      await productoModule.getproductos();
    }
    if (pedidoModule.pedidos.length === 0) {
      await pedidoModule.getpedidos();
    }
    
    // Solo no vendidos
    this.productos = productoModule.productos.filter(p => !p.vendido); 
    
    this.cargando = false;
  }

  get pedidosDisponibles() {
    return pedidoModule.pedidos.map(p => ({
      text: p.referencia || p.nombre_archivo_importar || `Pedido ${p.id}`,
      value: p.id
    }));
  }

  get productosFiltrados() {
    let filtrados = this.productos;

    if (this.pedidoIds.length > 0) {
      filtrados = filtrados.filter(p => this.pedidoIds.includes(p.id_pedido));
    }

    if (this.estadoFiltro !== "todos") {
      filtrados = filtrados.filter(p => p.estado.toString() === this.estadoFiltro);
    }

    if (this.search) {
      const s = this.search.toLowerCase();
      filtrados = filtrados.filter(p => 
        (p.asin && p.asin.toLowerCase().includes(s)) ||
        (p.item_desc && p.item_desc.toLowerCase().includes(s)) ||
        (p.lpn && p.lpn.toLowerCase().includes(s))
      );
    }

    return filtrados;
  }

  getImg(item: producto) {
    if (item.asin) {
      // Trick para cargar imagenes de amazon via ASIN
      return `https://images-na.ssl-images-amazon.com/images/P/${item.asin}.01._SCLZZZZZZZ_.jpg`;
    }
    return API.webApiBaseRootPath + "Image/ProductImage/" + item.id + "_1.jpg";
  }

  getEstadoName(estado: number) {
    switch (estado) {
      case 0: return "Disponible";
      case 1: return "Reservado";
      case 2: return "Pdte. Pago";
      case 3: return "Merma";
      case 4: return "Envío";
      case 7: return "Reparación";
      default: return "Estado " + estado;
    }
  }

  getBadgeClass(estado: number) {
    switch (estado) {
      case 0: return "badge-success";
      case 3: return "badge-error";
      case 7: return "badge-warning";
      case 1: 
      case 2:
      case 4: return "badge-info";
      default: return "badge-grey";
    }
  }

  irAFicha(item: producto) {
    this.$router.push({ name: RouterNames.fichaproducto, params: { id: item.id.toString() } }).catch(()=>{});
  }
}
